export const DESKTOP_BREAKPOINT = 768;
export const MOBILE_LANDSCAPE_BREAKPOINT = 640;
export const HOME_PAGE_WIDTH_BREAKPOINT = 1380;
